import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  filter: PropTypes.string,
  currentFilter: PropTypes.string,
  onFilter: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]).isRequired,
  xsCols: PropTypes.number,
};

const defaultProps = {
  filter: null,
  currentFilter: null,
  onFilter: () => {},
  xsCols: 6,
};

const FilterOption = ({
  children,
  filter,
  currentFilter,
  onFilter,
  xsCols,
}) => {
  const handleFilter = useCallback(() => {
    onFilter({ filter });
  }, [filter, onFilter]);

  const classNames = cx({
    'col-md-2': true,
    [`col-xs-${xsCols}`]: true,
    'h5-sg': true,
    'text-center': true,
    clickable: filter !== currentFilter,
    'text-color-dark-slate': filter === currentFilter,
  });

  return (
    <div className={classNames} onClick={handleFilter}>
      {children}
    </div>
  );
};

FilterOption.propTypes = propTypes;
FilterOption.defaultProps = defaultProps;

export default FilterOption;
